<script setup lang="ts">
import CurrencyText from '@uiKit/components/CurrencyText.vue'
import Box from '@uiKit/elements/Box.vue'
import AppButton from '@uiKit/elements/Button.vue'
import Dialog from '@uiKit/elements/Dialog.vue'
import Text from '@uiKit/elements/Text.vue'
import FailureCrossAnimation from '@uiKit/components/FailureCrossAnimation.vue'

interface Props {
  visible: boolean
  message: string
}

defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:visible', val: boolean): void
}>()

const close = () => emit('update:visible', false)

const onDialogUpdate = (value: boolean) => {
  if (!value) close()
}
</script>

<template>
  <Dialog
    :model-value="visible"
    width="400px"
    :show-close-icon="false"
    @update:model-value="onDialogUpdate"
  >
    <Box direction="col" align="center" gap="4" class="withdrawal-error">
      <FailureCrossAnimation />
      <Box direction="col" gap="2">
        <Text type="title-lg" align="center">Withdrawal Failed</Text>
        <Text type="body" color="muted" align="center"><CurrencyText :text="message" /></Text>
      </Box>
      <AppButton label="Close" block @click="close" />
    </Box>
  </Dialog>
</template>

<style scoped>
.withdrawal-error {
  padding: 1rem 0.5rem 0.25rem;
}
</style>
